import request from '@/utils/request'

const jdataName = '/api-gateway/jpaas-jdata-server/front/dataAnalysis/'
const jdataNamePhone = '/api-gateway/jpaas-jdata-server/front/showpage/'
const jdataProduct = '/api-gateway/jpaas-jdata-server/front/dataproduct/'

const api = {
  pageDetail: jdataName + 'getpage',
  getMapJson: jdataName + 'mapjson', // 获取地区地图
  getCustom: jdataProduct + 'getcustom',
  getData: jdataProduct + 'getdata',
  getThemList: jdataNamePhone + 'showthemlist', // 获取主题列表
  getPageList: jdataNamePhone + 'showpagelist', // 获取演示页面列表
  getHost: jdataNamePhone + 'getdomainpath', // 获取演示页面列表
  getRegion: jdataProduct + 'get-region' //获取地区树
}
export const JDATA_API = {
  pageDetail(params) {
    return request({
      url: api.pageDetail,
      method: 'get',
      params
    })
  },
  getCustom(data) {
    return request({
      url: api.getCustom,
      method: 'post',
      data
    })
  },
  getData(data) {
    return request({
      url: api.getData,
      method: 'post',
      data
    })
  },
  getThemList(data) {
    return request({
      url: api.getThemList,
      method: 'post',
      data
    })
  },
  getPageList(data) {
    return request({
      url: api.getPageList,
      method: 'post',
      data
    })
  },
  getMapJson(params) {
    return request({
      url: api.getMapJson,
      method: 'get',
      params
    })
  },
  getHost(params) {
    return request({
      url: api.getHost,
      method: 'get',
      params
    })
  },
  getRegion(params) {
    return request({
      url: api.getRegion,
      method: 'get',
      params
    })
  }
}
